import { Injectable } from '@angular/core';
import { AlertifyService } from './alertify.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private alertify: AlertifyService) { }

  handleCertificateError(error: any): void {
    let userMessage = 'An error occurred while processing your certificate.';
    
    if (error.status === 403) {
      userMessage = 'Course not yet completed. Please finish all classes first.';
    } else if (error.status === 404) {
      userMessage = 'Certificate not found. Please contact support.';
    } else if (error.status === 500) {
      userMessage = 'Server error. Please try again later.';
    } else if (error.name === 'TimeoutError') {
      userMessage = 'Request timed out. Please check your connection and try again.';
    }
    
    this.alertify.error(userMessage);
    console.error('Certificate error details:', error);
  }
}
